import { VideoAtividadeDTO } from "./videoAtividadeDTO";

export class AtividadeProgramaDTO {
    id: number;
    idprogramatreino: number;
    titulo: string;
	ordem: number;
	descricao: string;

    videoProgramaAtividade: Array<VideoAtividadeDTO>;
}